Vue.component('ack-partner-and-distributors-selector', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-partner-and-distributors-selector',
	mixins: [languageMixins],

	mounted() {},
	props: {
		selectorName: {
			type: String,
			required: true,
		},
		selectorId: {
			type: String,
			required: true,
		},
		options: {
			type: Array,
			required: true,
		},
		currentValue: {
			type: String,
			required: true,
		},
	},
	created() {},
	computed: {},
	data() {
		return {
			pageId: 'partner-and-distributors-selector',
		};
	},
	methods: {
		onClearSelector() {
			EventBus.$emit('onClearSelector');
		},
	},
	beforeDestroy() {},
	watch: {},
});
